import gql from 'graphql-tag'

export const INSERT_SUPPORT_TICKET = gql`
mutation insert_support_ticket($object: [Supports_insert_input!]!, $customerId: uuid!, $customerObject: Customer_set_input){
  insert_Supports(objects: $object) {
    returning{id}
  }
  update_Customer(where: {id: {_eq: $customerId}}, _set: $customerObject) {
    returning {id}
  } 
}
`

export const UPDATE_SUPPORT_TICKET = gql`
mutation update_support_ticket($id: uuid!, $object: Supports_set_input, $customerId: uuid!, $customerObject: Customer_set_input) {
  update_Supports(where: {id: {_eq: $id}}, _set: $object) {
    returning {id}
  }
  update_Customer(where: {id: {_eq: $customerId}}, _set: $customerObject) {
    returning {id}
  } 
  }
`
export const UPDATE_SUPPORT_STATUS_INSERT_COMMENT = gql`
mutation update_support_ticket_insert_comment($supportId: uuid!, $object: Supports_set_input, $comment: String, $skipInsert: Boolean!){
  insert_SupportComments(objects: {comment: $comment, supportId: $supportId})  @skip(if: $skipInsert){
    returning{id}
  }
  update_Supports (where: {id: {_eq: $supportId}}, _set: $object) {
    returning {id}
    } 
}
`
export const INSERT_AMC_PLAN_HISTORY = gql`
mutation($serialNo:String!, $retailSalesId:uuid!,$supportPlanId:uuid!,$productId:uuid!,$startDate:timestamptz!,$endDate:timestamptz!,$noOfSupportRaised:Int!,$fromPartnerId:uuid!,$createdBy:uuid!,$updatedBy:uuid!,){
  insert_AMCPlanHistory(objects: {serialNo:$serialNo, retailSalesId:$retailSalesId,supportPlanId:$supportPlanId,productId:$productId,startDate:$startDate,endDate:$endDate,noOfSupportRaised:$noOfSupportRaised,fromPartnerId:$fromPartnerId,createdBy:$createdBy,updatedBy:$updatedBy}){
    returning{
      id
    }
  }
}`
